/* The Saber Company · Birthday Month calendar. Source: public/calendar/ */
(() => {
if (customElements.get('tsc-birthday-calendar')) return;
const COLORS = { deal: '#4da3ff', gift: '#3dff8f', giveaway: '#b36bff', refund: '#ff3b3b', flash: '#ffd23f' };
const TYPE_LABEL = { deal: 'Deal', gift: 'Free gift', giveaway: 'Giveaway', refund: 'First order free', flash: 'Flash sale' };
const CDN = 'https://cdn.shopify.com/s/files/1/0610/0933/0410';
const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
const LOCK_ICON = '<svg class="door__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
const pad = (n) => String(n).padStart(2, '0');
const esc = (v) => String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
const fmt = (date, options, timeZone) => new Intl.DateTimeFormat('en-GB', { timeZone, ...options }).format(date);
const localClock = (date) => new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' }).format(date);
function hms(ms) {
const t = Math.max(0, Math.floor(ms / 1000));
const d = Math.floor(t / 86400);
const clock = `${pad(Math.floor((t % 86400) / 3600))}:${pad(Math.floor((t % 3600) / 60))}:${pad(t % 60)}`;
return d > 0 ? `${d}d ${clock}` : clock;
}
function duration(sec) {
if (sec < 60) return `${sec} second${sec === 1 ? '' : 's'}`;
if (sec < 3600) return `${Math.floor(sec / 60)} min ${sec % 60} s`;
return `${Math.floor(sec / 3600)} h ${Math.floor((sec % 3600) / 60)} min`;
}
const money = (v, currency = 'USD') => new Intl.NumberFormat('en-US', { style: 'currency', currency, maximumFractionDigits: v % 1 ? 2 : 0 }).format(v);
function countryName(code) {
try { return new Intl.DisplayNames(['en'], { type: 'region' }).of(code); } catch { return code; }
}
function zonedParts(date, timeZone) {
const out = {};
for (const { type, value } of new Intl.DateTimeFormat('en-US', { timeZone, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(date)) {
if (type !== 'literal') out[type] = Number(value);
}
return out;
}
function zonedToUtc(year, month, day, timeZone) {
const target = Date.UTC(year, month - 1, day);
let guess = target;
for (let i = 0; i < 3; i++) {
const p = zonedParts(new Date(guess), timeZone);
const shown = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
if (shown === target) break;
guess += target - shown;
}
return new Date(guess);
}
function installGlobals() {
if (document.getElementById('tsc-bday-globals')) return;
const style = document.createElement('style');
style.id = 'tsc-bday-globals';
style.textContent = "@font-face{font-family:'CeraStencil';src:url('https://cdn.shopify.com/s/files/1/0610/0933/0410/files/Cera-Stencil-Regular.woff?v=1751462635') format('woff');font-weight:500;font-style:normal;font-display:swap}";
document.head.append(style);
try { CSS.registerProperty({ name: '--tsc-spin', syntax: '<angle>', inherits: false, initialValue: '0deg' }); } catch { /* already registered or unsupported */ }
}
function createSparks(canvas) {
const ctx = canvas.getContext('2d');
const particles = [];
let raf = 0;
let last = 0;
const hexA = (hex, a) => {
const n = parseInt(hex.slice(1), 16);
return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
};
function resize() {
const dpr = Math.min(devicePixelRatio || 1, 2);
canvas.width = innerWidth * dpr;
canvas.height = innerHeight * dpr;
ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}
function frame(t) {
const dt = Math.min(32, t - (last || t)) / 16.67;
last = t;
ctx.clearRect(0, 0, innerWidth, innerHeight);
ctx.globalCompositeOperation = 'lighter';
ctx.lineCap = 'round';
for (let i = particles.length - 1; i >= 0; i--) {
const p = particles[i];
p.life -= p.decay * dt;
if (p.life <= 0) { particles.splice(i, 1); continue; }
p.vx *= p.drag;
p.vy = p.vy * p.drag + p.gravity * dt;
p.x += p.vx * dt;
p.y += p.vy * dt;
const a = Math.max(0, p.life);
ctx.strokeStyle = p.core && a > 0.5 ? `rgba(255,255,255,${a})` : hexA(p.color, a);
ctx.lineWidth = p.size * (0.4 + a * 0.6);
ctx.beginPath();
ctx.moveTo(p.x - p.vx * p.trail, p.y - p.vy * p.trail);
ctx.lineTo(p.x, p.y);
ctx.stroke();
}
if (particles.length) raf = requestAnimationFrame(frame);
else { raf = 0; last = 0; ctx.clearRect(0, 0, innerWidth, innerHeight); }
}
const start = () => { if (!raf) raf = requestAnimationFrame(frame); };
resize();
addEventListener('resize', resize);
return {
burst(x, y, { count = 30, color = '#61aefe', speed = 8, spread = Math.PI * 2, angle = 0, gravity = 0.18, size = 2, trail = 2.2, decay = 0.022, drag = 0.965 } = {}) {
for (let i = 0; i < count; i++) {
const a = angle + (Math.random() - 0.5) * spread;
const s = speed * (0.35 + Math.random() * 0.9);
particles.push({ x, y, vx: Math.cos(a) * s, vy: Math.sin(a) * s, life: 0.7 + Math.random() * 0.5, decay: decay * (0.7 + Math.random() * 0.6), gravity, size: size * (0.6 + Math.random() * 0.8), trail, drag, color, core: Math.random() < 0.45 });
}
start();
},
rain(color, count = 70) {
const colors = [color, '#ffffff', '#61aefe'];
for (let i = 0; i < count; i++) {
particles.push({ x: Math.random() * innerWidth, y: -20 - Math.random() * innerHeight * 0.4, vx: (Math.random() - 0.5) * 1.5, vy: 2 + Math.random() * 4, life: 1, decay: 0.006 + Math.random() * 0.006, gravity: 0.04, size: 1.5 + Math.random() * 1.8, trail: 3.5, drag: 0.995, color: colors[i % 3], core: false });
}
start();
},
clear() { particles.length = 0; },
destroy() { particles.length = 0; cancelAnimationFrame(raf); removeEventListener('resize', resize); },
};
}
function createSound() {
const KEY = 'tsc-bday-sound';
let ctx = null;
let master = null;
let hum = null;
let enabled = true;
try { enabled = localStorage.getItem(KEY) !== 'off'; } catch { /* storage blocked */ }
function ensure() {
if (!enabled) return false;
const AC = window.AudioContext || window.webkitAudioContext;
if (!AC) return false;
if (!ctx) {
ctx = new AC();
master = ctx.createGain();
master.gain.value = 0.55;
master.connect(ctx.createDynamicsCompressor()).connect(ctx.destination);
}
if (ctx.state === 'suspended') ctx.resume();
return true;
}
function noise(seconds) {
const buf = ctx.createBuffer(1, ctx.sampleRate * seconds, ctx.sampleRate);
const data = buf.getChannelData(0);
for (let i = 0; i < data.length; i++) data[i] = Math.random() * 2 - 1;
const src = ctx.createBufferSource();
src.buffer = buf;
return src;
}
function env(param, t, points) {
param.setValueAtTime(points[0][1], t);
for (const [dt, v] of points.slice(1)) param.linearRampToValueAtTime(v, t + dt);
}
function filter(type, freq, q) {
const f = ctx.createBiquadFilter();
f.type = type;
f.frequency.value = freq;
if (q) f.Q.value = q;
return f;
}
function osc(type, freq) {
const o = ctx.createOscillator();
o.type = type;
o.frequency.value = freq;
return o;
}
const api = {
get enabled() { return enabled; },
set enabled(v) {
enabled = v;
try { localStorage.setItem(KEY, v ? 'on' : 'off'); } catch { /* storage blocked */ }
if (!v) api.stopHum();
},
ignite() {
if (!ensure()) return;
const t = ctx.currentTime;
const g = ctx.createGain();
const lp = filter('lowpass', 300);
env(lp.frequency, t, [[0, 300], [0.25, 2400], [0.6, 700]]);
env(g.gain, t, [[0, 0], [0.04, 0.5], [0.3, 0.28], [0.7, 0]]);
for (const [type, f0, f1] of [['sawtooth', 55, 118], ['square', 56.5, 121]]) {
const o = osc(type, f0);
o.frequency.setValueAtTime(f0, t);
o.frequency.exponentialRampToValueAtTime(f1, t + 0.28);
o.connect(lp);
o.start(t);
o.stop(t + 0.75);
}
const n = noise(0.4);
const ng = ctx.createGain();
env(ng.gain, t, [[0, 0.35], [0.3, 0]]);
n.connect(filter('bandpass', 1800, 0.6)).connect(ng).connect(master);
n.start(t);
lp.connect(g).connect(master);
},
hum() {
if (!ensure() || hum) return;
const t = ctx.currentTime;
const g = ctx.createGain();
g.gain.setValueAtTime(0, t);
g.gain.linearRampToValueAtTime(0.16, t + 0.25);
const lp = filter('lowpass', 420);
const lfo = osc('sine', 5.5);
const lfoGain = ctx.createGain();
lfoGain.gain.value = 1.6;
lfo.connect(lfoGain);
const oscs = [90, 92.4, 180.5].map((f, i) => {
const o = osc(i === 2 ? 'triangle' : 'sawtooth', f);
lfoGain.connect(o.frequency);
o.connect(lp);
o.start(t);
return o;
});
lfo.start(t);
lp.connect(g).connect(master);
hum = { g, nodes: [...oscs, lfo] };
},
stopHum() {
if (!hum || !ctx) return;
const t = ctx.currentTime;
hum.g.gain.cancelScheduledValues(t);
hum.g.gain.setValueAtTime(hum.g.gain.value, t);
hum.g.gain.linearRampToValueAtTime(0, t + 0.35);
hum.nodes.forEach((o) => o.stop(t + 0.4));
hum = null;
},
swing() {
if (!ensure()) return;
const t = ctx.currentTime;
const n = noise(0.5);
const bp = filter('bandpass', 350, 2.2);
env(bp.frequency, t, [[0, 350], [0.14, 2600], [0.42, 500]]);
const g = ctx.createGain();
env(g.gain, t, [[0, 0], [0.1, 0.9], [0.45, 0]]);
n.connect(bp).connect(g).connect(master);
n.start(t);
const o = osc('sawtooth', 190);
o.frequency.setValueAtTime(190, t);
o.frequency.exponentialRampToValueAtTime(70, t + 0.4);
const og = ctx.createGain();
env(og.gain, t, [[0, 0], [0.08, 0.22], [0.42, 0]]);
o.connect(filter('lowpass', 900)).connect(og).connect(master);
o.start(t);
o.stop(t + 0.5);
},
clash() {
if (!ensure()) return;
const t = ctx.currentTime;
const n = noise(0.3);
const g = ctx.createGain();
env(g.gain, t, [[0, 0.9], [0.18, 0]]);
n.connect(filter('highpass', 1500)).connect(g).connect(master);
n.start(t);
for (const f of [1320, 2210]) {
const o = osc('sine', f);
const og = ctx.createGain();
env(og.gain, t, [[0, 0.12], [0.5, 0]]);
o.connect(og).connect(master);
o.start(t);
o.stop(t + 0.55);
}
},
chime() {
if (!ensure()) return;
const t = ctx.currentTime;
[523.25, 783.99, 1046.5].forEach((f, i) => {
const o = osc('sine', f);
const g = ctx.createGain();
const s = t + i * 0.07;
g.gain.setValueAtTime(0, s);
g.gain.linearRampToValueAtTime(0.14, s + 0.02);
g.gain.exponentialRampToValueAtTime(0.0001, s + 1.2);
o.connect(g).connect(master);
o.start(s);
o.stop(s + 1.3);
});
},
denied() {
if (!ensure()) return;
const t = ctx.currentTime;
const o = osc('square', 110);
o.frequency.linearRampToValueAtTime(80, t + 0.15);
const g = ctx.createGain();
env(g.gain, t, [[0, 0.12], [0.18, 0]]);
o.connect(filter('lowpass', 600)).connect(g).connect(master);
o.start(t);
o.stop(t + 0.2);
},
};
return api;
}
const legendItem = (type, name, desc) => `<div class="legend__item" data-type="${type}"><div class="blade"></div><span class="legend__name">${name}</span><span class="legend__desc">${desc}</span></div>`;
function mainMarkup(o) {
return `
<div class="wrap">
<div class="preview-bar" hidden><span>Admin preview · viewing as <strong class="js-preview-time"></strong></span><a href="/admin">Back to admin</a><a href="/">Exit preview</a></div>
<section class="hero">
<div class="hero__glow" aria-hidden="true"></div>
<button class="sound-toggle" type="button" aria-pressed="true">
<span class="sound-toggle__bars" aria-hidden="true"><i></i><i></i><i></i></span><span class="js-sound-label">Sound on</span>
</button>
<p class="eyebrow js-eyebrow">${esc(o.brand)} turns ${esc(o.yearsOld)}</p>
<h1 class="hero__title"><span class="grad">${esc(o.heading)}</span></h1>
<div class="blade hero__blade" aria-hidden="true"></div>
<p class="hero__sub">October is our birthday month. Every day at <strong class="js-unlock-time">00:00</strong> a new door unlocks: deals, free gear, website-only giveaways and orders we refund in full.</p>
<div class="countdown">
<p class="countdown__label js-countdown-label">&nbsp;</p>
<div class="countdown__grid" role="timer" aria-live="off">
${['d:Days', 'h:Hours', 'm:Minutes', 's:Seconds'].map((x) => { const [u, l] = x.split(':'); return `<div class="countdown__cell"><span class="countdown__value grad--soft" data-unit="${u}">00</span><span class="countdown__unit">${l}</span></div>`; }).join('')}
</div>
<p class="countdown__local js-countdown-local"></p>
</div>
<div class="hero__actions">
<button class="btn btn--primary js-open-today" type="button" hidden>Open today's door</button>
<button class="btn btn--ghost js-scroll-calendar" type="button">View the calendar</button>
</div>
</section>
<section class="test" hidden aria-label="Test door">
<div class="test__door"></div>
<div class="test__body">
<p class="eyebrow">Test door · only visible in preview</p>
<h2 class="test__title grad--soft">Try the reveal</h2>
<p class="test__text">Pick an offer type, then open the door. Everything behind it is sample content: the codes don't work and entries aren't saved.</p>
<div class="test__chips">
${[['deal', 'Deal'], ['gift', 'Free gift'], ['giveaway', 'Giveaway'], ['refund', 'First order free'], ['refund-claimed', 'First order · claimed'], ['flash-upcoming', 'Flash · starting soon'], ['flash', 'Flash · live']]
.map(([k, l], i) => `<button class="chip${i === 0 ? ' is-active' : ''}" type="button" data-test-kind="${k}" data-type="${k.split('-')[0]}"><span class="chip__blade"></span>${l}</button>`).join('')}
</div>
<p class="test__setup js-setup-note" hidden>Setup mode: no calendar server connected, so every door shows as locked. Add the server URL in the theme editor to go live.</p>
</div>
</section>
<section class="legend-wrap" aria-label="What's behind the doors">
<div class="legend">
${legendItem('deal', 'Deal', 'A one-day discount code')}
${legendItem('gift', 'Free gift', 'Free gear or a saber with your order')}
${legendItem('giveaway', 'Giveaway', 'Enter here. Only on this page')}
${legendItem('refund', 'First order free', 'Fastest order gets refunded in full')}
${legendItem('flash', 'Flash sale', "A few hours only. Blink and it's gone")}
</div>
</section>
<section class="calendar" aria-label="Birthday calendar">
<div class="calendar__head">
<div><p class="eyebrow">The birthday calendar</p><h2 class="section-title grad js-month">October</h2></div>
<div class="progress"><span class="progress__text js-progress-text">0 / 31 doors unlocked</span><div class="progress__bar"><div class="progress__fill js-progress-fill"></div></div></div>
</div>
<div class="weekdays" aria-hidden="true"><span>Mon</span><span>Tue</span><span>Wed</span><span>Thu</span><span>Fri</span><span>Sat</span><span>Sun</span></div>
<ol class="doors" aria-live="polite"></ol>
</section>
<section class="how" aria-label="How it works">
<p class="eyebrow">How it works</p>
<h2 class="section-title grad">Three steps</h2>
<div class="how__grid">
<div class="how__step"><span class="how__num grad--soft">01</span><h3>Come back daily</h3><p>A new door unlocks every night at midnight. Each one is only live for that day.</p></div>
<div class="how__step"><span class="how__num grad--soft">02</span><h3>Open the door</h3><p>Deals, free gear, giveaways and orders we refund. You won't know which until you open it.</p></div>
<div class="how__step"><span class="how__num grad--soft">03</span><h3>Claim it today</h3><p>Codes expire, giveaways close and refund races end at 23:59. Don't sleep on it.</p></div>
</div>
</section>
<section class="faq" aria-label="Good to know">
<h2 class="section-title grad">Good to know</h2>
<details><summary>When do doors unlock?</summary><p class="js-faq-unlock">Every day in October at 00:00 Amsterdam time. Each door stays live until 23:59 the same day.</p></details>
<details><summary>How does "First order free" work?</summary><p>On First Order Free days, the first order placed after the door opens (meeting the minimum order total) gets a full refund. Order times come straight from our store, down to the second, and the door shows live when it's been claimed.</p></details>
<details><summary>How do giveaways work?</summary><p>Giveaways are only on this page. No purchase needed, one entry per person per giveaway. Entries close at 23:59. We pick a random winner, email them, and show their first name on the door.</p></details>
<details><summary>Can I combine codes?</summary><p>Birthday codes can't be combined with other discount codes. Each code only works on its own day (or during its flash window).</p></details>
<details><summary>I missed a door. Can I still use it?</summary><p>Sorry, no. Past doors stay visible so you can see what you missed, but their codes stop working at midnight.</p></details>
</section>
</div>`;
}
const LAYER_MARKUP = `
<div class="reveal" role="dialog" aria-modal="true" aria-label="Door reveal" hidden>
<div class="reveal__backdrop" data-close></div>
<div class="stage" hidden></div>
<article class="offer" hidden></article>
<button class="reveal__close" type="button" data-close aria-label="Close">×</button>
<button class="reveal__skip" type="button" hidden>Tap to skip</button>
</div>
<canvas class="fx-canvas" aria-hidden="true"></canvas>
<div class="toast" role="status" aria-live="polite"></div>`;
function mount(host) {
installGlobals();
const attr = (name, fallback = '') => host.getAttribute(name) || fallback;
const params = new URLSearchParams(location.search);
const o = {
api: host.hasAttribute('api') ? host.getAttribute('api') : null,
styles: attr('styles'),
storeUrl: attr('store-url', 'https://thesabercompany.com').replace(/\/$/, ''),
heading: attr('heading', '31 Doors'),
brand: attr('brand', 'The Saber Company'),
timezone: attr('timezone', 'Europe/Amsterdam'),
year: Number(attr('year', '2026')),
month: Number(attr('month', '10')),
yearsOld: attr('years-old', '6'),
rulesUrl: attr('rules-url'),
};
const previewParam = o.api !== null ? params.get('preview') : null;
const testMode = host.getAttribute('test-door');
const testCode = (host.getAttribute('test-code') || '').trim();
const showTest = testMode !== null && (testMode === 'always' || params.has('test-door') || host.hasAttribute('design-mode'));
const STORE_PREFIX = previewParam ? 'tsc-bday-preview' : 'tsc-bday';
const cleanup = [];
const root = host.shadowRoot || host.attachShadow({ mode: 'open' });
const stylesheet = o.styles ? `<link rel="stylesheet" href="${esc(o.styles)}">` : '';
root.innerHTML = `<style>:host{display:block;background:#000;min-height:60vh}.wrap{opacity:0}</style>${stylesheet}${mainMarkup(o)}`;
const layerHost = document.createElement('tsc-birthday-layer');
layerHost.style.cssText = 'position:fixed;inset:0;z-index:2147483000;pointer-events:none;display:block';
const layer = layerHost.attachShadow({ mode: 'open' });
layer.innerHTML = `<style>canvas{position:fixed;inset:0;width:100vw;height:100vh}.toast{opacity:0}</style>${stylesheet}${LAYER_MARKUP}`;
document.body.append(layerHost);
const $ = (sel) => root.querySelector(sel) || layer.querySelector(sel);
const $$ = (sel) => [...root.querySelectorAll(sel), ...layer.querySelectorAll(sel)];
const activeEl = () => layer.activeElement || root.activeElement;
const sound = createSound();
const sparks = createSparks($('.fx-canvas'));
const state = { data: null, offset: 0, openDay: null, openData: null, lastFocus: null, runner: null, pollTimer: 0, refreshTimer: 0, renderedSig: '', firstRender: true, testKind: 'deal' };
const saved = {
list(key) { try { return JSON.parse(localStorage.getItem(`${STORE_PREFIX}-${key}`)) || []; } catch { return []; } },
has(key, day) { return this.list(key).includes(day); },
add(key, day) {
const list = this.list(key);
if (list.includes(day)) return;
list.push(day);
try { localStorage.setItem(`${STORE_PREFIX}-${key}`, JSON.stringify(list)); } catch { /* storage blocked */ }
},
};
const now = () => new Date(Date.now() + state.offset);
const tz = () => state.data?.campaign.timezone || o.timezone;
const city = () => tz().split('/').pop().replace(/_/g, ' ');
const clock = (date) => fmt(date, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }, tz());
const sameZone = (date) => fmt(date, { dateStyle: 'short', timeStyle: 'short' }, tz()) === fmt(date, { dateStyle: 'short', timeStyle: 'short' });
const when = (date) => { const d = new Date(date); return `${clock(d)} ${city()} time${sameZone(d) ? '' : ` (${localClock(d)} your time)`}`; };
const longDate = (iso) => fmt(new Date(iso), { weekday: 'long', day: 'numeric', month: 'long' }, tz());
const shortDate = (iso) => fmt(new Date(iso), { weekday: 'short', day: 'numeric', month: 'short' }, tz());
const doorNum = (d) => (d.test ? 'TEST' : pad(d.day));
const dayData = (day) => (day === 0 ? state.openData : state.data.days.find((d) => d.day === day));
const apiBase = o.api === null ? null : new URL(o.api ? o.api.replace(/\/?$/, '/') : '/', location.href);
const onStore = (() => {
try { return new URL(o.storeUrl).origin === location.origin; } catch { return false; }
})();
async function api(path, options = {}) {
const url = new URL(path.replace(/^\//, ''), apiBase);
if (previewParam) url.searchParams.set('preview', state.data?.preview ? now().toISOString() : previewParam);
const res = await fetch(url, { headers: { 'Content-Type': 'application/json' }, ...options });
const body = await res.json().catch(() => ({}));
if (!res.ok) throw Object.assign(new Error(body.error || 'Something went wrong. Please try again.'), { status: res.status, body });
if (body.now) state.offset = Date.parse(body.now) - Date.now();
return body;
}
function offlineCalendar() {
const total = new Date(Date.UTC(o.year, o.month, 0)).getUTCDate();
const days = [];
for (let day = 1; day <= total; day++) {
days.push({ day, status: 'locked', unlocksAt: zonedToUtc(o.year, o.month, day, o.timezone).toISOString(), endsAt: zonedToUtc(o.year, o.month, day + 1, o.timezone).toISOString() });
}
const next = days.find((d) => Date.parse(d.unlocksAt) > Date.now());
return {
offline: true,
campaign: { brand: o.brand, yearsOld: o.yearsOld, timezone: o.timezone, storeUrl: o.storeUrl, rulesUrl: o.rulesUrl, startsAt: days[0].unlocksAt, endsAt: days.at(-1).endsAt },
now: new Date().toISOString(),
preview: false,
activeDay: null,
nextUnlock: next ? { day: next.day, at: next.unlocksAt } : null,
days,
};
}
async function loadCalendar() {
if (apiBase) {
try {
state.data = await api('/api/calendar');
} catch (err) {
if (!state.data) state.data = offlineCalendar();
console.warn('[birthday calendar] API unavailable', err);
}
} else {
state.data = offlineCalendar();
}
renderPage();
}
async function refreshDay(day) {
if (!day || state.data.offline) return;
const { day: fresh } = await api(`/api/day/${day}`);
const i = state.data.days.findIndex((d) => d.day === day);
state.data.days[i] = fresh;
updateDoor(fresh);
if (state.openDay === day && !$('.offer').hidden) syncOffer(fresh);
}
function scheduleRefresh() {
clearTimeout(state.refreshTimer);
state.refreshTimer = setTimeout(async () => {
if (state.openDay === 0 && state.openData?.flash?.phase === 'upcoming' && Date.parse(state.openData.flash.startsAt) <= Date.now()) {
syncOffer(testDoorData('flash', state.openData));
return;
}
await loadCalendar().catch(() => {});
if (state.openDay) await refreshDay(state.openDay).catch(() => {});
}, 700);
}
function renderPage() {
const { campaign, preview } = state.data;
$('.js-eyebrow').textContent = `${campaign.brand} turns ${campaign.yearsOld} · ${fmt(new Date(campaign.startsAt), { month: 'long', year: 'numeric' }, campaign.timezone)}`;
$('.js-month').textContent = fmt(new Date(campaign.startsAt), { month: 'long' }, campaign.timezone);
$('.js-unlock-time').textContent = `00:00 ${city()} time`;
const first = new Date(campaign.startsAt);
$('.js-faq-unlock').textContent = `Every day at 00:00 ${city()} time${sameZone(first) ? '' : ` (${localClock(first)} your time)`}. Each door stays live until 23:59 the same day.`;
$('.preview-bar').hidden = !preview;
$('.test').hidden = !showTest;
$('.js-setup-note').hidden = !(showTest && state.data.offline);
renderDoors();
const unlocked = state.data.days.filter((d) => d.status !== 'locked').length;
$('.js-progress-text').textContent = `${unlocked} / ${state.data.days.length} doors unlocked`;
$('.js-progress-fill').style.width = `${(unlocked / state.data.days.length) * 100}%`;
tick();
}
function renderDoors() {
const list = $('.doors');
const { days } = state.data;
if (list.children.length && list.dataset.count === String(days.length)) {
days.forEach(updateDoor);
return;
}
list.replaceChildren();
list.dataset.count = days.length;
const weekday = fmt(new Date(days[0].unlocksAt), { weekday: 'short' }, tz());
const blanks = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(weekday);
for (let i = 0; i < blanks; i++) {
const li = document.createElement('li');
li.className = 'doors__blank';
li.setAttribute('aria-hidden', 'true');
list.append(li);
}
days.forEach((d, i) => {
const li = document.createElement('li');
li.dataset.day = d.day;
li.append(doorEl(d));
list.append(li);
if (state.firstRender && !reduceMotion) {
li.animate([{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'none' }], { duration: 500, delay: 120 + i * 22, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'backwards' });
}
});
state.firstRender = false;
}
function updateDoor(d) {
const li = root.querySelector(`.doors li[data-day="${d.day}"]`);
if (!li) return;
const next = doorEl(d);
if (li.firstElementChild?.dataset.sig === next.dataset.sig) return;
const hadFocus = li.contains(root.activeElement);
li.replaceChildren(next);
if (hadFocus) next.focus();
}
function doorEl(d, { stage = false } = {}) {
const el = document.createElement(stage ? 'div' : 'button');
if (!stage) el.type = 'button';
el.dataset.doorDay = d.day;
const unlock = new Date(d.unlocksAt);
const opened = !d.test && saved.has('opened', d.day);
const soon = d.status === 'locked' && state.data.nextUnlock?.day === d.day && unlock - now() < 86400_000;
const top = d.test
? `<span class="door__top"><span>Test</span><span>${esc(fmt(new Date(), { weekday: 'short' }, tz()))}</span></span>`
: `<span class="door__top"><span>${esc(fmt(unlock, { month: 'short' }, tz()))}</span><span>${esc(fmt(unlock, { weekday: 'short' }, tz()))}</span></span>`;
const num = `<span class="door__num grad--soft">${doorNum(d)}</span>`;
const media = d.product?.image ? `<span class="door__media"><img src="${esc(d.product.image)}" alt="" loading="lazy"></span>` : '';
let cls = `door${d.test ? ' door--test' : ''}`;
let body = '';
let bottom = '';
let label = '';
if (stage) {
cls += ' door--today';
bottom = `<span>${d.test ? 'Test door' : `Door ${pad(d.day)}`}</span><span class="door__pill">Today</span>`;
} else if (d.status === 'locked') {
cls += ` door--locked${soon ? ' door--soon' : ''}`;
bottom = soon ? `<span data-countdown="${d.unlocksAt}">--:--:--</span>${LOCK_ICON}` : `<span>Locked</span>${LOCK_ICON}`;
label = `Door ${d.day}, locked until ${shortDate(d.unlocksAt)}`;
} else if (d.status === 'active' && !opened) {
cls += ' door--today';
bottom = `<span>${d.test ? 'Sample' : 'Today'}</span><span class="door__pill">Open</span>`;
label = d.test ? 'Test door. Open it' : `Door ${d.day}, unlocked today. Open it`;
} else {
const past = d.status === 'past';
cls += past ? ' door--past' : ' door--opened';
body = `${media}<span class="door__badge">${TYPE_LABEL[d.type]}</span><span class="door__title">${esc(d.title)}</span>`;
bottom = past ? `<span class="door__stamp">${esc(pastStamp(d))}</span>` : '<span>Live now</span><span>View →</span>';
label = `Door ${d.day}, ${TYPE_LABEL[d.type]}: ${d.title}${past ? ', ended' : ''}`;
}
el.className = cls;
if (d.type && !stage && !d.test && (d.status === 'past' || opened)) el.dataset.type = d.type;
el.innerHTML = `${top}${num}${body}<span class="door__bottom">${bottom}</span>`;
if (label) el.setAttribute('aria-label', label);
el.dataset.sig = [d.status, opened, soon, d.title, d.winner?.label, d.claim?.claimedAt].join('|');
return el;
}
function pastStamp(d) {
if (d.type === 'giveaway') return d.winner ? `Won by ${d.winner.label}` : 'Entries closed';
if (d.type === 'refund') return d.claim ? 'Claimed' : 'Ended';
return 'Ended';
}
function testDoorData(kind, prev) {
const t = Date.now();
const type = kind.split('-')[0];
const base = {
day: 0, test: true, type, status: 'active',
unlocksAt: new Date(t - 3600_000).toISOString(),
endsAt: prev?.endsAt || new Date(t + 6 * 3600_000).toISOString(),
finePrint: 'Sample fine print. Real doors show the terms you set for each offer.',
};
const shop = `${o.storeUrl}/collections/all`;
switch (kind) {
case 'deal':
return { ...base, title: '15% off every saber', subtitle: 'Sample deal', description: testCode
? `This is what a deal door looks like. The button applies the real code ${testCode} to your cart, exactly like a live door does.`
: 'This is what a deal door looks like. The code below is a sample and won\'t work at checkout.', code: testCode || 'TESTDOOR', shopUrl: shop, shopPath: '/collections/all', ctaLabel: 'Shop all sabers', product: { name: 'Knight | Saber', price: 159.99, image: `${CDN}/files/JHH1646.jpg?v=1774870144&width=900` } };
case 'gift':
return { ...base, title: 'Free Premium Stand', subtitle: 'With any saber', description: 'Every saber ordered today ships with a Saber Stand | Premium. Your hilt deserves a throne.', code: testCode || 'TESTGIFT', shopUrl: shop, shopPath: '/collections/all', ctaLabel: 'Pick your saber', product: { name: 'Saber Stand | Premium', price: 70, image: `${CDN}/files/HD_9777.jpg?v=1740433917&width=900` } };
case 'giveaway':
return { ...base, title: 'Win the Tano 2 Piece', subtitle: 'Website-only giveaway', description: 'Two blades, one lucky winner. Enter below. No purchase needed.', prize: 'Tano 2 Piece | Saber', worth: 599.99, entries: 1284, entryOpen: true, winner: null, product: { name: 'Tano 2 Piece | Saber', price: 599.99, image: `${CDN}/files/JHH3517.jpg?v=1780584715&width=900` } };
case 'refund':
case 'refund-claimed':
return { ...base, title: 'First order is on us', subtitle: 'Birthday kick-off', description: 'The very first order placed after this door opened gets a 100% refund. Every second counts.', minOrderTotal: 100, currency: 'USD', shopUrl: shop, ctaLabel: 'Shop all sabers', claim: kind === 'refund-claimed' ? { label: 'S.', country: 'DE', claimedAt: new Date(t - 3600_000 + 19_000).toISOString(), secondsAfterOpen: 19 } : null };
case 'flash-upcoming':
case 'flash': {
const upcoming = kind === 'flash-upcoming';
const startsAt = prev?.flash?.startsAt || new Date(upcoming ? t + 15_000 : t - 3600_000).toISOString();
const endsAt = prev?.flash?.endsAt || new Date(t + 3 * 3600_000).toISOString();
const phase = Date.parse(startsAt) > t ? 'upcoming' : 'live';
return { ...base, title: 'Six hours. Six years.', subtitle: '20% off sitewide', description: upcoming ? 'This flash sale starts in 15 seconds. Keep the door open and watch the code unlock.' : 'For a few hours only, everything is 20% off.', flash: { startsAt, endsAt, phase }, ...(phase === 'live' ? { code: testCode || 'TESTFLASH', shopUrl: shop, shopPath: '/collections/all', ctaLabel: 'Shop the flash sale' } : {}) };
}
default:
return testDoorData('deal');
}
}
function renderTestDoor() {
const d = testDoorData(state.testKind);
const wrap = $('.test__door');
const el = doorEl(d);
el.dataset.type = d.type;
wrap.replaceChildren(el);
}
function tick() {
if (!state.data) return;
const t = now();
for (const el of $$('[data-countdown]')) {
const ms = Date.parse(el.dataset.countdown) - (el.closest('.offer') && state.openDay === 0 ? Date.now() : t);
el.textContent = hms(ms);
if (ms <= 0 && !el.dataset.fired) {
el.dataset.fired = '1';
scheduleRefresh();
}
}
const { activeDay, nextUnlock, campaign, preview } = state.data;
const label = $('.js-countdown-label');
const openBtn = $('.js-open-today');
let target = null;
if (activeDay) {
label.textContent = nextUnlock ? `Door ${pad(activeDay)} is open · next door in` : 'The final door closes in';
target = nextUnlock ? nextUnlock.at : campaign.endsAt;
openBtn.hidden = false;
openBtn.textContent = `${saved.has('opened', activeDay) ? 'View' : 'Open'} door ${pad(activeDay)}`;
openBtn.dataset.day = activeDay;
} else if (nextUnlock) {
label.textContent = `Door ${pad(nextUnlock.day)} unlocks in`;
target = nextUnlock.at;
openBtn.hidden = true;
} else {
label.textContent = "That's a wrap. Thanks for celebrating with us";
openBtn.hidden = true;
}
const ms = target ? Math.max(0, Date.parse(target) - t) : 0;
const parts = { d: Math.floor(ms / 86400_000), h: Math.floor(ms / 3600_000) % 24, m: Math.floor(ms / 60_000) % 60, s: Math.floor(ms / 1000) % 60 };
for (const el of root.querySelectorAll('.countdown__value')) {
const text = pad(parts[el.dataset.unit]);
if (el.textContent !== text) el.textContent = text;
}
if (target && ms <= 0) scheduleRefresh();
$('.js-countdown-local').textContent = nextUnlock ? `${shortDate(nextUnlock.at)} · ${when(nextUnlock.at)}` : '';
if (preview) $('.js-preview-time').textContent = `${fmt(t, { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }, tz())} ${city()}`;
}
root.addEventListener('click', (e) => {
const chip = e.target.closest('[data-test-kind]');
if (chip) {
state.testKind = chip.dataset.testKind;
root.querySelectorAll('[data-test-kind]').forEach((c) => c.classList.toggle('is-active', c === chip));
renderTestDoor();
return;
}
const btn = e.target.closest('button.door');
if (btn?.classList.contains('door--test')) {
openReveal(testDoorData(state.testKind), { animate: true, fromEl: btn });
return;
}
if (btn) return onDoor(Number(btn.dataset.doorDay), btn);
if (e.target.closest('.js-open-today')) {
const day = Number(e.target.closest('.js-open-today').dataset.day);
return onDoor(day, root.querySelector(`button.door[data-door-day="${day}"]`));
}
if (e.target.closest('.js-scroll-calendar')) return $('.calendar').scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
if (e.target.closest('.sound-toggle')) {
sound.enabled = !sound.enabled;
syncSoundButton();
if (sound.enabled) sound.ignite();
}
});
function onDoor(day, btn) {
const d = dayData(day);
if (!d) return;
if (d.status === 'locked') {
sound.denied();
if (btn && !reduceMotion) {
btn.classList.remove('is-shaking');
void btn.offsetWidth;
btn.classList.add('is-shaking');
}
toast(`Door ${day} unlocks ${shortDate(d.unlocksAt)} at ${when(d.unlocksAt)}`);
return;
}
openReveal(d, { animate: d.status === 'active' && !saved.has('opened', day), fromEl: btn });
}
async function openReveal(d, { animate, fromEl }) {
if (state.openDay !== null) return;
state.openDay = d.day;
state.openData = d.test ? d : null;
state.lastFocus = activeEl();
const reveal = $('.reveal');
const offer = $('.offer');
reveal.hidden = false;
document.documentElement.style.overflow = 'hidden';
offer.hidden = true;
renderOffer(d);
if (!d.test) setUrlDay(d.day);
if (animate && !reduceMotion) {
await playReveal(d, fromEl);
} else {
$('.reveal__backdrop').animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200 });
offer.hidden = false;
offer.animate([{ opacity: 0, transform: 'translateY(14px) scale(.98)' }, { opacity: 1, transform: 'none' }], { duration: 320, easing: 'cubic-bezier(.2,.8,.2,1)' });
if (animate) sound.chime();
}
if (state.openDay !== d.day) return;
if (!d.test && d.status === 'active' && !saved.has('opened', d.day)) {
saved.add('opened', d.day);
updateDoor(d);
tick();
}
startPolling(d);
$('.reveal__close').focus({ preventScroll: true });
}
function closeReveal() {
if (state.openDay === null) return;
state.runner?.skip();
state.runner = null;
sound.stopHum();
sparks.clear();
stopPolling();
if (state.openDay) setUrlDay(null);
state.openDay = null;
state.openData = null;
const reveal = $('.reveal');
const done = () => {
if (state.openDay !== null) return;
reveal.hidden = true;
$('.offer').hidden = true;
$('.stage').hidden = true;
$('.stage').replaceChildren();
$('.reveal__skip').hidden = true;
document.documentElement.style.overflow = '';
};
if (reduceMotion) done();
else reveal.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 180 }).finished.then(done);
state.lastFocus?.focus?.({ preventScroll: true });
}
function runner() {
const running = new Set();
const timers = new Set();
let skipped = false;
return {
get skipped() { return skipped; },
anim(el, keyframes, options) {
const a = el.animate(keyframes, { fill: 'forwards', ...options });
if (skipped) a.finish();
running.add(a);
return a.finished.catch(() => {}).finally(() => running.delete(a));
},
wait(ms) {
if (skipped) return Promise.resolve();
return new Promise((resolve) => {
const entry = { resolve, id: setTimeout(() => { timers.delete(entry); resolve(); }, ms) };
timers.add(entry);
});
},
skip() {
skipped = true;
running.forEach((a) => a.finish());
timers.forEach((t) => { clearTimeout(t.id); t.resolve(); });
timers.clear();
},
};
}
async function playReveal(d, fromEl) {
const r = (state.runner = runner());
const color = COLORS[d.type];
const stage = $('.stage');
const offer = $('.offer');
const skipBtn = $('.reveal__skip');
const finish = () => {
sound.stopHum();
stage.hidden = true;
stage.replaceChildren();
skipBtn.hidden = true;
if (offer.hidden) { offer.hidden = false; sound.chime(); }
offer.getAnimations().forEach((a) => a.finish());
state.runner = null;
};
const face = doorEl(d, { stage: true });
const blade = document.createElement('div');
blade.className = 'stage__blade';
blade.innerHTML = '<div class="blade" style="height:100%;width:100%;animation:none"></div>';
blade.style.setProperty('--c', color);
blade.style.opacity = '0';
const flash = document.createElement('div');
flash.className = 'stage__flash';
flash.style.setProperty('--c', color);
stage.replaceChildren(face, blade, flash);
stage.hidden = false;
skipBtn.hidden = false;
r.anim($('.reveal__backdrop'), [{ opacity: 0 }, { opacity: 1 }], { duration: 350 });
const to = stage.getBoundingClientRect();
let from = 'translateY(40px) scale(.7)';
if (fromEl) {
const f = fromEl.getBoundingClientRect();
from = `translate(${f.left + f.width / 2 - (to.left + to.width / 2)}px, ${f.top + f.height / 2 - (to.top + to.height / 2)}px) scale(${f.width / to.width})`;
}
sound.ignite();
await r.anim(stage, [{ transform: from, opacity: 0.4 }, { transform: 'none', opacity: 1 }], { duration: 650, easing: 'cubic-bezier(.2,.9,.1,1)' });
if (r.skipped) return finish();
sound.hum();
const num = face.querySelector('.door__num');
num.style.transition = 'text-shadow .6s ease';
num.style.textShadow = `0 0 30px ${color}, 0 0 60px ${color}`;
const box = stage.getBoundingClientRect();
const edgeSparks = setInterval(() => {
const side = Math.random() < 0.5;
const x = side ? box.left + Math.random() * box.width : box.left + (Math.random() < 0.5 ? 0 : box.width);
const y = side ? box.top + (Math.random() < 0.5 ? 0 : box.height) : box.top + Math.random() * box.height;
sparks.burst(x, y, { count: 5, color, speed: 3, gravity: 0.08, size: 1.4 });
}, 70);
await r.anim(face, [
{ transform: 'none', boxShadow: '0 0 40px -10px rgba(97,174,254,.6)' },
{ transform: 'translate(-2px,1px) rotate(-.5deg)', offset: 0.3 },
{ transform: 'translate(3px,-1px) rotate(.6deg)', offset: 0.55 },
{ transform: 'translate(-2px,0) rotate(-.3deg)', offset: 0.8 },
{ transform: 'none', boxShadow: `0 0 120px 10px ${color}` },
], { duration: 750, easing: 'ease-in' });
clearInterval(edgeSparks);
if (r.skipped) return finish();
const w = box.width;
const h = box.height;
const x0 = w * 1.12;
const y0 = -h * 0.1;
const x1 = -w * 0.12;
const y1 = h * 1.1;
const angle = Math.atan2(y1 - y0, x1 - x0);
blade.style.width = `${Math.hypot(x1 - x0, y1 - y0)}px`;
blade.style.opacity = '1';
const base = `translate(${x0}px, ${y0 - 3}px) rotate(${angle}rad)`;
sound.swing();
const slashMs = 190;
const t0 = performance.now();
const trail = () => {
const p = Math.min(1, (performance.now() - t0) / slashMs);
sparks.burst(box.left + x0 + (x1 - x0) * p, box.top + y0 + (y1 - y0) * p, { count: 7, color, speed: 6, angle: angle - Math.PI / 2, spread: Math.PI, gravity: 0.25 });
if (p < 1 && !r.skipped) requestAnimationFrame(trail);
};
requestAnimationFrame(trail);
await r.anim(blade, [{ transform: `${base} scaleX(0)` }, { transform: `${base} scaleX(1)` }], { duration: slashMs, easing: 'cubic-bezier(.6,0,.9,.4)' });
if (r.skipped) return finish();
sound.stopHum();
sound.clash();
const pieceA = document.createElement('div');
const pieceB = document.createElement('div');
pieceA.className = pieceB.className = 'stage__piece';
pieceA.style.clipPath = 'polygon(-20% -20%, 112% -10%, -12% 110%)';
pieceB.style.clipPath = 'polygon(112% -10%, 120% 120%, -12% 110%)';
for (const p of [pieceA, pieceB]) {
const f = face.cloneNode(true);
f.style.boxShadow = `0 0 120px 10px ${color}`;
f.querySelector('.door__num').style.textShadow = `0 0 30px ${color}, 0 0 60px ${color}`;
p.append(f);
}
face.replaceWith(pieceA, pieceB);
const cx = box.left + w / 2;
const cy = box.top + h / 2;
sparks.burst(cx, cy, { count: 110, color, speed: 14, gravity: 0.22, size: 2.4 });
sparks.burst(cx, cy, { count: 40, color: '#ffffff', speed: 9, gravity: 0.15, size: 1.6 });
r.anim(flash, [{ opacity: 0 }, { opacity: 1, offset: 0.2 }, { opacity: 0 }], { duration: 520, easing: 'ease-out' });
r.anim(blade, [{ opacity: 1 }, { opacity: 0 }], { duration: 260, delay: 60 });
const fall = { duration: 900, easing: 'cubic-bezier(.4,0,.8,.3)' };
r.anim(pieceA, [{ transform: 'none', opacity: 1 }, { transform: 'translate(-4%, -3%) rotate(-2deg)', opacity: 1, offset: 0.15 }, { transform: 'translate(-55%, -30%) rotate(-24deg)', opacity: 0 }], fall);
const piecesDone = r.anim(pieceB, [{ transform: 'none', opacity: 1 }, { transform: 'translate(4%, 3%) rotate(2deg)', opacity: 1, offset: 0.15 }, { transform: 'translate(50%, 60%) rotate(22deg)', opacity: 0 }], fall);
await r.wait(220);
offer.hidden = false;
sound.chime();
sparks.rain(color);
r.anim(offer, [
{ opacity: 0, transform: 'scale(.88)', filter: 'blur(14px) brightness(2.2)' },
{ opacity: 1, transform: 'none', filter: 'blur(0) brightness(1)' },
], { duration: 700, easing: 'cubic-bezier(.2,.9,.2,1)', fill: 'none' });
await piecesDone;
return finish();
}
layer.addEventListener('click', async (e) => {
if (e.target.closest('.reveal__close')) return closeReveal();
if (state.runner && !e.target.closest('.offer')) return state.runner.skip();
if (e.target.closest('[data-close]')) return closeReveal();
const copy = e.target.closest('[data-copy]');
if (copy) {
await copyText(copy.dataset.copy);
copy.classList.add('is-copied');
copy.querySelector('span').textContent = 'Copied';
const r = copy.getBoundingClientRect();
sparks.burst(r.right - 40, r.top + r.height / 2, { count: 24, color: COLORS[$('.offer').dataset.type], speed: 5 });
toast(`Code ${copy.dataset.copy} copied`);
setTimeout(() => { copy.classList.remove('is-copied'); copy.querySelector('span').textContent = 'Copy'; }, 2000);
}
const apply = e.target.closest('[data-apply]');
if (apply) {
e.preventDefault();
if (apply.dataset.busy) return;
apply.dataset.busy = '1';
const label = apply.textContent;
apply.textContent = 'Applying discount…';
let cart = null;
try {
const res = await fetch(`/discount/${encodeURIComponent(apply.dataset.apply)}?redirect=${encodeURIComponent('/cart.js')}`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
if (res.ok) cart = await res.json();
} catch { /* fall back to the plain discount link below */ }
if (!cart) { location.href = apply.href; return; }
apply.textContent = label;
delete apply.dataset.busy;
location.href = cart.item_count > 0 ? '/cart' : apply.dataset.path;
return;
}
if (e.target.closest('[data-share]') && state.openDay) {
const url = new URL(location.href);
url.searchParams.set('day', state.openDay);
url.searchParams.delete('preview');
await copyText(url.toString());
toast('Link copied. Share the birthday!');
}
});
function onKey(e) {
if (state.openDay === null) return;
if (e.key === 'Escape') return closeReveal();
if (e.key !== 'Tab') return;
const focusable = [...layer.querySelectorAll('button:not([hidden]):not([disabled]), a[href], input:not(.hp)')].filter((el) => el.offsetParent !== null);
if (!focusable.length) return;
const first = focusable[0];
const last = focusable.at(-1);
if (e.shiftKey && layer.activeElement === first) { e.preventDefault(); last.focus(); }
else if (!e.shiftKey && layer.activeElement === last) { e.preventDefault(); first.focus(); }
}
document.addEventListener('keydown', onKey);
cleanup.push(() => document.removeEventListener('keydown', onKey));
function renderOffer(d) {
const offer = $('.offer');
offer.dataset.type = d.type;
offer.dataset.status = d.status;
offer.setAttribute('aria-labelledby', 'offer-title');
const rules = state.data?.campaign.rulesUrl || o.rulesUrl;
const eyebrow = d.test ? `Test door · ${esc(TYPE_LABEL[d.type])} sample` : `Door ${pad(d.day)} · ${esc(longDate(d.unlocksAt))}`;
offer.innerHTML = `
<div class="offer__media">${offerMedia(d)}</div>
<div class="offer__body">
<div class="offer__eyebrow"><span class="eyebrow">${eyebrow}</span><span class="badge">${TYPE_LABEL[d.type]}</span></div>
<h2 class="offer__title grad--soft" id="offer-title">${esc(d.title)}</h2>
${d.subtitle ? `<p class="offer__subtitle">${esc(d.subtitle)}</p>` : ''}
<div class="blade offer__blade" aria-hidden="true"></div>
${d.description ? `<p class="offer__desc">${esc(d.description)}</p>` : ''}
<div class="offer__action"></div>
${d.finePrint ? `<p class="offer__fine">${esc(d.finePrint)}${rules ? ` <a href="${esc(rules)}" target="_blank" rel="noopener">Full rules</a>` : ''}</p>` : ''}
<div class="offer__foot">
<span>${d.status === 'active' ? `Door closes in <strong data-countdown="${d.endsAt}">--:--:--</strong>` : `Closed ${esc(shortDate(d.endsAt))}`}</span>
${d.test ? '<span>Sample content</span>' : '<button class="link-btn" type="button" data-share>Copy link</button>'}
</div>
</div>`;
renderAction(d);
tick();
}
function offerMedia(d) {
const worth = d.type === 'giveaway' && d.worth ? `Worth ${d.product ? '' : 'up to '}${money(d.worth)}`
: d.type === 'gift' && d.product?.price ? `Worth ${money(d.product.price)}`
: d.product?.name || '';
const chip = worth ? `<span class="offer__worth">${esc(worth)}</span>` : '';
if (d.product?.image) return `<img src="${esc(d.product.image)}" alt="${esc(d.product.name)}">${chip}`;
const angles = d.type === 'giveaway' && !d.product ? [-14, 0, 14] : [0];
return `<div class="art" aria-hidden="true">${angles.map((a) => `<div class="art__saber" style="--r:${a}deg"><div class="blade"></div><div class="art__hilt"></div></div>`).join('')}</div>${chip}`;
}
const actionSig = (d) => JSON.stringify([d.status, d.flash?.phase, d.code, d.claim, d.winner, !d.test && saved.has('entered', d.day)]);
const note = (text) => `<p class="note">${esc(text)}</p>`;
const doneBlock = (title, text) => `<div class="done"><span class="done__title grad--soft">${esc(title)}</span><p>${esc(text)}</p></div>`;
function renderAction(d) {
const el = $('.offer__action');
if (!el) return;
state.renderedSig = actionSig(d);
const active = d.status === 'active';
switch (d.type) {
case 'deal':
case 'gift':
el.innerHTML = active && d.code ? codeBlock(d) : note("This door has closed and its code no longer works. Keep an eye on today's door.");
break;
case 'flash': {
const { phase, startsAt, endsAt } = d.flash;
const s = new Date(startsAt);
const e = new Date(endsAt);
const endLabel = clock(e) === '00:00' ? 'midnight' : clock(e);
const windowText = `${clock(s)}–${endLabel} ${city()} time${sameZone(s) ? '' : ` · ${localClock(s)}–${localClock(e)} your time`}`;
if (phase === 'upcoming') {
el.innerHTML = `
<div class="flash-timer"><span class="flash-timer__label">Flash sale starts in</span><strong class="flash-timer__value" data-countdown="${startsAt}">--:--:--</strong><span class="flash-timer__window">${esc(windowText)}</span></div>
<div class="code"><span class="code__label">Your code</span><div class="code__value code__value--locked">••••••••<span>Unlocks at ${esc(clock(s))}</span></div></div>
<a class="btn btn--ghost btn--block" href="${esc(o.storeUrl)}/collections/all" target="_blank" rel="noopener">Pick your saber in advance</a>`;
} else if (phase === 'live') {
el.innerHTML = `
<div class="flash-timer"><span class="flash-timer__label">Live now · ends in</span><strong class="flash-timer__value" data-countdown="${endsAt}">--:--:--</strong><span class="flash-timer__window">${esc(windowText)}</span></div>
${codeBlock(d)}`;
} else {
el.innerHTML = note(active ? `This flash sale ran ${windowText} and has ended.` : 'This flash sale has ended.');
}
break;
}
case 'giveaway': {
const entered = !d.test && saved.has('entered', d.day);
el.innerHTML = `
<div class="stats">
<div class="stat"><span class="stat__value">${d.worth ? esc(money(d.worth)) : 'Free'}</span><span class="stat__label">Prize value</span></div>
<div class="stat"><span class="stat__value js-entry-count">${Number(d.entries || 0).toLocaleString('en-US')}</span><span class="stat__label">Fans entered</span></div>
</div>
${active ? (entered ? doneBlock("You're in", "Your entry is saved. We'll email you if you win. Good luck!") : entryForm())
: d.winner ? doneBlock(`Won by ${d.winner.label}`, 'Congratulations! The winner has been contacted by email.')
: note('Entries are closed. The winner will be announced here soon.')}`;
el.querySelector('form')?.addEventListener('submit', (ev) => submitEntry(ev, d));
break;
}
case 'refund': {
const min = d.minOrderTotal ? ` Minimum order ${money(d.minOrderTotal, d.currency)}.` : '';
if (d.claim) {
const who = [d.claim.label, d.claim.country ? `from ${countryName(d.claim.country)}` : ''].filter(Boolean).join(' ') || 'A fan';
const at = new Date(d.claim.claimedAt);
el.innerHTML = `
<div class="race race--claimed"><span class="race__dot" aria-hidden="true"></span>
<div><strong>Claimed</strong><p>${esc(who)} ordered ${esc(duration(d.claim.secondsAfterOpen))} after the door opened, at ${esc(clock(at))}:${pad(at.getSeconds())}. Their order is on us.</p></div></div>
${active ? note('Missed it? There are more First Order Free doors this month. Be ready at midnight.') : ''}`;
} else if (active) {
el.innerHTML = `
<div class="race"><span class="race__dot" aria-hidden="true"></span>
<div><strong>Up for grabs</strong><p>No qualifying order yet. The next order placed wins a full refund.${esc(min)}</p></div></div>
<a class="btn btn--primary btn--block" href="${esc(d.shopUrl)}" target="_blank" rel="noopener">${esc(d.ctaLabel)} →</a>`;
} else {
el.innerHTML = note('This refund race has ended.');
}
break;
}
}
}
function codeBlock(d) {
const applyAttrs = onStore ? ` data-apply="${esc(d.code)}" data-path="${esc(d.shopPath || '/collections/all')}"` : ' target="_blank" rel="noopener"';
return `
<div class="code"><span class="code__label">Your code</span><button class="code__value" type="button" data-copy="${esc(d.code)}">${esc(d.code)}<span>Copy</span></button></div>
<a class="btn btn--primary btn--block" href="${esc(d.shopUrl)}"${applyAttrs}>${esc(d.ctaLabel)} · discount applied →</a>`;
}
function entryForm() {
const rules = state.data?.campaign.rulesUrl || o.rulesUrl;
return `
<form class="entry" novalidate>
<div class="field"><label class="sr-only" for="entry-name">Full name</label><input id="entry-name" name="name" autocomplete="name" placeholder="Full name" maxlength="80" required></div>
<div class="field"><label class="sr-only" for="entry-email">Email</label><input id="entry-email" name="email" type="email" autocomplete="email" inputmode="email" placeholder="Email address" maxlength="254" required></div>
<input class="hp" name="company" tabindex="-1" autocomplete="off" aria-hidden="true">
<label class="check"><input type="checkbox" name="consent" required> <span>I'm 18+ (or have permission) and accept the ${rules ? `<a href="${esc(rules)}" target="_blank" rel="noopener">giveaway rules</a>` : 'giveaway rules'}.</span></label>
<label class="check"><input type="checkbox" name="marketing"> <span>Email me future drops and deals from The Saber Company.</span></label>
<button class="btn btn--primary btn--block" type="submit">Enter the draw</button>
<p class="form-msg" role="alert"></p>
</form>`;
}
async function submitEntry(e, d) {
e.preventDefault();
const form = e.currentTarget;
const btn = form.querySelector('button[type="submit"]');
const msg = form.querySelector('.form-msg');
const data = new FormData(form);
const payload = { name: String(data.get('name') || ''), email: String(data.get('email') || ''), consent: data.get('consent') === 'on', marketing: data.get('marketing') === 'on', company: String(data.get('company') || '') };
form.querySelectorAll('input').forEach((i) => i.removeAttribute('aria-invalid'));
const fail = (text, field) => {
msg.textContent = text;
const input = field && form.elements[field];
if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
};
if (payload.name.trim().length < 2) return fail('Please enter your name.', 'name');
if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(payload.email.trim())) return fail('Please enter a valid email address.', 'email');
if (!payload.consent) return fail('Please accept the giveaway rules to enter.', 'consent');
msg.textContent = '';
btn.disabled = true;
btn.textContent = 'Entering…';
try {
const res = d.test
? await new Promise((resolve) => setTimeout(() => resolve({ ok: true, test: true, entries: d.entries + 1 }), 600))
: await api(`/api/giveaway/${d.day}/enter`, { method: 'POST', body: JSON.stringify(payload) });
if (!res.preview && !res.test) saved.add('entered', d.day);
const r = btn.getBoundingClientRect();
sparks.burst(r.left + r.width / 2, r.top + r.height / 2, { count: 60, color: COLORS.giveaway, speed: 9 });
sound.chime();
const [title, text] = res.test ? ["You're in", 'Test door: this is what fans see after entering. Nothing was saved.']
: res.preview ? ['Preview only', 'Preview mode: this entry was not saved.']
: res.duplicate ? ['Already in', "This email is already entered for today's draw. One entry per person. Good luck!"]
: ["You're in", "Your entry is saved. We'll email you if you win. Good luck!"];
form.outerHTML = doneBlock(title, text);
if (typeof res.entries === 'number') {
d.entries = res.entries;
const count = $('.js-entry-count');
if (count) count.textContent = res.entries.toLocaleString('en-US');
}
state.renderedSig = actionSig(d);
} catch (err) {
btn.disabled = false;
btn.textContent = 'Enter the draw';
fail(err.status ? err.message : 'Could not reach the giveaway. Please try again.', err.body?.field);
}
}
function syncOffer(d) {
const offer = $('.offer');
if (d.test) state.openData = d;
if (offer.dataset.status && d.status !== offer.dataset.status) {
renderOffer(d);
} else if (actionSig(d) !== state.renderedSig) {
if (!offer.querySelector('form')?.contains(layer.activeElement)) renderAction(d);
} else if (d.type === 'giveaway') {
const count = $('.js-entry-count');
if (count) count.textContent = Number(d.entries || 0).toLocaleString('en-US');
}
offer.dataset.status = d.status;
tick();
}
function startPolling(d) {
stopPolling();
if (d.test || state.data.offline || d.status !== 'active' || !['refund', 'giveaway', 'flash'].includes(d.type)) return;
state.pollTimer = setInterval(() => refreshDay(d.day).catch(() => {}), d.type === 'refund' ? 8000 : 30000);
}
function stopPolling() { clearInterval(state.pollTimer); state.pollTimer = 0; }
async function copyText(text) {
try {
await navigator.clipboard.writeText(text);
} catch {
const ta = document.createElement('textarea');
ta.value = text;
ta.style.cssText = 'position:fixed;opacity:0';
document.body.append(ta);
ta.select();
document.execCommand('copy');
ta.remove();
}
}
function setUrlDay(day) {
const url = new URL(location.href);
if (day) url.searchParams.set('day', day);
else url.searchParams.delete('day');
history.replaceState(history.state, '', url);
}
let toastTimer = 0;
function toast(text) {
const el = $('.toast');
el.textContent = text;
el.classList.add('is-visible');
clearTimeout(toastTimer);
toastTimer = setTimeout(() => el.classList.remove('is-visible'), 3200);
}
function syncSoundButton() {
$('.sound-toggle').setAttribute('aria-pressed', String(sound.enabled));
$('.js-sound-label').textContent = sound.enabled ? 'Sound on' : 'Sound off';
}
syncSoundButton();
if (showTest) renderTestDoor();
const ready = loadCalendar().then(() => {
if (previewParam && !state.data.preview) toast('Preview is only available when signed in to /admin.');
const deepLink = Number(params.get('day'));
const d = deepLink && dayData(deepLink);
if (d?.status === 'locked') toast(`Door ${deepLink} unlocks ${shortDate(d.unlocksAt)} at ${when(d.unlocksAt)}`);
else if (d) onDoor(deepLink, root.querySelector(`button.door[data-door-day="${deepLink}"]`));
});
const tickTimer = setInterval(tick, 1000);
const reloadTimer = setInterval(() => { if (!document.hidden && apiBase) loadCalendar().catch(() => {}); }, 60_000);
const onVisible = () => { if (!document.hidden && apiBase) loadCalendar().catch(() => {}); };
document.addEventListener('visibilitychange', onVisible);
cleanup.push(() => {
clearInterval(tickTimer);
clearInterval(reloadTimer);
stopPolling();
document.removeEventListener('visibilitychange', onVisible);
sound.stopHum();
sparks.destroy();
layerHost.remove();
document.documentElement.style.overflow = '';
});
return { ready, destroy: () => cleanup.forEach((fn) => fn()) };
}
customElements.define('tsc-birthday-calendar', class extends HTMLElement {
connectedCallback() {
if (!this.instance) this.instance = mount(this);
}
disconnectedCallback() {
this.instance?.destroy();
this.instance = null;
}
});
})();